// @flow
import type {ChartType} from '@/types'

import React from 'react'
import {map} from 'ramda'

import './chart-selector.css'

import styled, {css} from 'styled-components'
import {selectThemeColours} from '@/theme-colours'
import {getSessionPartnerId} from '@/partnerID'

type Props = {
  onClick: (ChartType) => void,
  options: Array<{type: string, name: string}>,
  selected: ChartType,
}

const ChartSelector = styled.li`
${(props) => props.isActive && css`
  color: #ffffff;
  border-radius: 4px;`
}
`

const Button = styled.button`
${(props) => props.isActive && css`
  background-color: ${(props) => props.themeColours.secondaryColour};
  border-color: ${(props) => props.themeColours.secondaryColour};`
}
${(props) => !props.isActive && css`
  color: #5f5c5c;
  background-color: transparent;
  border-color: transparent;`
}

${(props) => !props.isActive
    ? `&:hover { color: ${props.themeColours.secondaryColour}; background-color: transparent; border: none } `
    : `&:hover { background-color: ${props.themeColours.secondaryColour} }`}

${(props) => !props.isActive
    ? ''
    : `&:focus { background-color: ${props.themeColours.secondaryColour}; border-color: ${props.themeColours.secondaryColour} }`}
`

const RawChartSelector = (props: Props) => {
  const themeColour = selectThemeColours(getSessionPartnerId())
  const renderListItem = (chart) =>
    <ChartSelector key={chart.type} className={props.selected === chart.type ? 'active' : ''} themeColours={themeColour}>
      <Button type="button" themeColours={themeColour} className="btn btn-danger" isActive={props.selected === chart.type} id={chart.id} onClick={() => props.onClick(chart.type)}>{chart.name}</Button>
    </ChartSelector>

  const renderList = map(renderListItem)

  return (
    <ul className="nav nav-pills chart-selector">
      {renderList(props.options)}
    </ul>
  )
}

export default RawChartSelector



// WEBPACK FOOTER //
// ./src/views/events-graph/chart-selector.js